/*
==========================================================
HDY CUSTOM MEGA MENU
Theme : Dawn 15.5.0
Author: BerryBeans
==========================================================
*/

document.addEventListener('DOMContentLoaded', () => {

    const megaMenus = document.querySelectorAll('.mega-menu');

    if (!megaMenus.length) return;

    /**
     * Close all menus
     */
    const closeAllMenus = (except = null) => {

        megaMenus.forEach(menu => {

            if (menu !== except) {
                menu.removeAttribute('open');
            }

        });

    };

    /**
     * One menu open at a time
     */
    megaMenus.forEach(menu => {

        const summary = menu.querySelector('summary');

        if (!summary) return;

        summary.addEventListener('click', () => {

            if (!menu.hasAttribute('open')) {
                closeAllMenus(menu);
            }

        });

    });

    /**
     * Click outside closes menu
     */
    document.addEventListener('click', (event) => {

        const insideMegaMenu = event.target.closest('.mega-menu');

        if (!insideMegaMenu) {
            closeAllMenus();
        }

    });

    /**
     * ESC closes menu
     */
    document.addEventListener('keydown', (event) => {

        if (event.key === 'Escape') {
            closeAllMenus();
        }

    });

    /**
     * Close when a product link is clicked
     */
    document.querySelectorAll('.hdy-product-card').forEach(card => {

        card.addEventListener('click', () => {
            closeAllMenus();
        });

    });

});